import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";

export default function FormulasTab({ inst, setFormula, rmFormula }) {
  return (
    <div className="p-6 rounded-2xl border border-border bg-card space-y-3">
      <div className="text-sm text-muted-foreground">Compose custom scoring expressions. Available variables: <code className="font-mono text-xs bg-secondary px-1.5 py-0.5 rounded">total</code>, <code className="font-mono text-xs bg-secondary px-1.5 py-0.5 rounded">n</code>, and per-dimension <code className="font-mono text-xs bg-secondary px-1.5 py-0.5 rounded">dim_&lt;code&gt;_sum</code>, <code className="font-mono text-xs bg-secondary px-1.5 py-0.5 rounded">dim_&lt;code&gt;_avg</code>, <code className="font-mono text-xs bg-secondary px-1.5 py-0.5 rounded">dim_&lt;code&gt;_count</code>. Example: <code className="font-mono">total * 2 - dim_A_sum</code>.</div>
      <div className="space-y-2">
        {Object.entries(inst.scoring.formulas || {}).map(([target, expr]) => (
          <div key={target} className="grid grid-cols-12 gap-2 items-center" data-testid={`formula-row-${target}`}>
            <Input value={target} readOnly className="col-span-3 h-9 font-mono text-xs" />
            <Input value={expr} onChange={(e) => setFormula(target, e.target.value)} className="col-span-8 h-9 font-mono" />
            <Button size="icon" variant="ghost" onClick={() => rmFormula(target)} className="text-destructive"><Trash2 className="w-4 h-4" /></Button>
          </div>
        ))}
        <div className="flex items-center gap-2 pt-2">
          <Input placeholder="target (e.g. total or dim_A_sum)" id="formula-target" className="h-9 font-mono max-w-xs" data-testid="formula-target" />
          <Input placeholder="expression" id="formula-expr" className="h-9 font-mono flex-1" data-testid="formula-expr" />
          <Button data-testid="formula-add-btn" size="sm" onClick={() => {
            const t = document.getElementById("formula-target").value.trim();
            const e = document.getElementById("formula-expr").value.trim();
            if (t && e) { setFormula(t, e); document.getElementById("formula-target").value = ""; document.getElementById("formula-expr").value = ""; }
          }}><Plus className="w-3 h-3 mr-1" /> Add</Button>
        </div>
      </div>
    </div>
  );
}
